import globalStore from '/globalStore.js';
import sharedUtil from "/shared.js";
import api from "/api2.js";


const timesheetHelpers = {

	//TODO: Rename to "getAllocatedToLabel"
	//NOTE: Keep synced with function in API class Entities.TimesheetExt.
	// param @firstOrLast: Is the first or last bucket of the day.
	getAssignmentLabel(AllocatedTo, BucketID, BucketName, firstOrLast)
	{
		// console.log("   timesheet-helpers.getAssignmentLabel(): AllocatedTo=", AllocatedTo, " | BucketID=", BucketID, " | BucketName=", BucketName, " | firstOrLast=", firstOrLast);
		if (AllocatedTo == "UserInactive") 
		{
			if (firstOrLast == true)
			{
				return "(Idle - out of work hours)";
			}

			return "(Inactive)";
		}

		if (AllocatedTo == "Ignore") return "(Ignore)";

		if (AllocatedTo == "Unallocated") return "(Unallocated)";

		if (AllocatedTo == "Personal") return "(Personal)";

		if (AllocatedTo == "WriteOff") return "(Miscellaneous)";

		if (AllocatedTo == "") return "[" + AllocatedTo + "]";

		// Project
		//return "<small>" + AllocatedTo + "</small>:" + (BucketID == "" ? "(Unallocated)" : BucketName)
		//return "" + BucketName + " <small>(Project)</small>";

		//BucketName = BucketName.replace(">", "›");
		//BucketName = BucketName.replace(">", "➾");
		//BucketName = BucketName.replace(">", "&rarr;");
		//BucketName = BucketName.replace(">", "→");

		return BucketName;
	},




	getBucketDisplayLabel(allocatedTo, bucketName)
	{
		// console.log("timesheetHelpers.getBucketDisplayLabel(): allocatedTo=", allocatedTo, " | bucketName=", bucketName);
		//return allocatedTo + "|" + bucketName;

		if (allocatedTo == "Unallocated") return "(Unallocated)";
		if (allocatedTo == "UserInactive") return "(Inactive)";
		if (allocatedTo == "Personal") return "(Personal)";
		if (allocatedTo == "WriteOff") return "(Miscellaneous)";
		if (allocatedTo == "Ignore") return "(Ignore)";
		return bucketName == "" ? "(Unallocated)" : bucketName;
	},







	









	
	/**
	 * Calculate the total reportable minutes of the timesheet, excluding inactive, personal and ignorable time.
	 *     
	 * param {object} timesheet: The vue data property containing the complete timesheet object. Passed in from the Vue component.  
	 * param {array} allocationGroups: The Vue data propery containing the allocation groups to render in the page. Passed in from the Vue component.  
	 * param {string} allSequencesKey: A "key" to identify the allocation group that displays all sequences for a day. Passed in from the Vue component.
	 */
	getTimesheetTotalMinutes(timesheet, allocationGroups)
	{
		var total = 0;

		for (var i = 0; i < allocationGroups.length; i++)
		{
			var allocationGroup = allocationGroups[i];

			if (allocationGroup.IsReportableTime)
			{
				total = total + allocationGroup.TotalRunTimeSeconds;
			}
		}

		return Math.floor(total / 60);
	},






		getTodaysTimesheet(vueRoot, callback, showOverlay = false)
		{
			var date = globalStore.helpers.getTodayDate();
			var userId = globalStore.state.currentUser.userId;
			var reportingYear = date.getFullYear();
			var reportingMonth = date.getMonth() + 1;
			var reportingDay = date.getDate();

			this.getUserTimesheetsByDate(vueRoot, userId, reportingYear, reportingMonth, reportingDay, function (responseData) {
				console.log("timesheetHelpers.getTodaysTimesheet(): responseData=", responseData);

				callback(responseData);
			}, showOverlay);	
		},





		//NOTE: This is a copy from C:\Source\portal-front-end-v2\module.timesheets\timesheet-page-mixin.js
		/**
		 * Return a list of timesheets for a user on a specified date.  
		 * Should only return 1 record if it exists, otehrwise zero records.
		 */
		getUserTimesheetsByDate(vueRoot, userId, reportingYear, reportingMonth, reportingDay, callback, showOverlay = false)	
		{
			if (userId == "")
			{
				// No user selected. Don't call the API yet.
				return;
			}

			if (reportingDay == "" && reportingMonth == "" && reportingDay == "")
			{
				// No date selected. Don't call the API yet.
				return;
			}
			
			var requestData = {
				userId: userId,
				reportingYear: reportingYear,
				reportingMonth: reportingMonth,
				reportingDay: reportingDay
			};

			if (showOverlay) vueRoot.showProcessingOverlay();
			//sharedUtil.showOverlay();

			var apiEndpont = "";
			apiEndpont = "/Timesheets/GetUserTimesheetsForDate";

			//console.log("timesheetHelpers.getUserTimesheetsByDate(): requestData=", requestData);

			vueRoot.callApi1("GET", apiEndpont, requestData)
			.then((responseData) => {
				if (showOverlay) vueRoot.hideProcessingOverlay();
				//sharedUtil.hideOverlay();
				
				//console.log("timesheetHelpers.getUserTimesheetsByDate(): responseData=", responseData);
				
				if (responseData == null) 
				{
					callback(null);
					return;
				}

				callback(responseData);
			});
		},












		/**
		 * Populate Projects list all projects assigned to the current user in the current account.
		 */
		getActiveBucketsInAccountUserCanAccess(userId, accountId, callback)
		{
			var requestData = {
				accountID: accountId,
				userId: userId,

				LoadProjectHierarchy: false,
				LoadBucketAllowances: false,
				// LoadBucketProjects: false,	// TODO: [2026-08-16] not used since 2021, deprecating and removing now
				LoadClient: false,
				LoadParentBucket: false,
				LoadActiveTasks: false,
			};
			console.log("timesheetHelpers.getActiveBucketsInAccountUserCanAccess(): requestData=", requestData);

			let bucketsList = [];

			api.callApi("/Buckets/GetActiveBucketsInAccountUserCanAccess", requestData, "GET")
			.then((responseData) => {
				console.log("timesheetHelpers.getActiveBucketsInAccountUserCanAccess(): responseData=", responseData);
				
				if (responseData == null) 
				{
					callback();
					return;	// API failure
				}

				// Reset the Projects list
				let buckets = responseData.data.Buckets;

				bucketsList = this.createFlatHierarchyStandard(buckets);

				callback(bucketsList);
			});
		},



		//TODO: Do this here then pass it into the bucket-select element so it's not done for every render of bucket-select, and hopefully improve performance.
		createFlatHierarchyStandard(items)
		{
			var list = [];

			//console.log("createFlatHierarchyStandard(): items=", items);

			if (!items)
			{
				return [];
			}

			//console.log("items.length=", items.length);
			//console.log("typeof(items)=", typeof(items));
			
			items.forEach(item => {
				list.push({
					ID: item.ID,
					Label: item.FullPathTitle,
				});
			});

			
			// Sort alphabetically
			list.sort((a, b) => (a.Label.toLowerCase() > b.Label.toLowerCase()) ? 1 : -1);
			

			//console.log("createFlatHierarchyStandard(): list=", list);
			return list;
		},


};



export default timesheetHelpers;
